import React, { useEffect, useState } from "react";
import Button from "../../../../common/Button/Button";
import Card from "../../../../common/Card/Card";
import Table from "../../../../common/Table/Table";
import styles from "./InvestmentsCard.module.scss";
import goldIcon from "../../../../../assets/icons/asset-icons/gold.svg";
import { RightUpIcon } from "../../../../../assets/icons/svgicons";
import { ROUTES } from "../../../../../routes";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getSpotPriceAction,
  getUsersInvestmentAction,
  getUserInfoAction,
} from "../../../../../features/user/userSlice";
import { cutOffDecimal, formatPrice, toFix } from "../../../../../utils/utils";

const fields = [
  {
    label: "Asset",
  },
  {
    label: "Qty",
    sort: true,
  },
  // {
  //   label: "Locked Qty",
  //   sort: true,
  // },
  // {
  //   label: "Total Qty",
  //   sort: true,
  // },
  {
    label: "Spot Price",
    sort: true,
  },
  // {
  //   label: "Average Price",
  //   sort: true,
  //   className: "average_text",
  // },
  {
    label: "Change (24h)",
  },
  {
    label: "Action",
  },
];

const InvestmentsCard = ({
  viewButton,
  className,
  headerClassName,
  noContentVariant,
  noRecordClassName,
  noRecordContent,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [quantityOrder, setQuantityOrder] = useState(false);
  const [priceOrder, setPriceOrder] = useState(false);
  const [averageOrder, setAverageOrder] = useState(false);
  const [investmentList, setInvestmentList] = useState("");
  const [callbackData, setCallbackData] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [profitSharig, setProfitSharing] = useState("");
  const userData = useSelector((state) => state?.persist?.userInfo);
  const profitPrices = useSelector((state) => state?.users?.profitPrice);
  const decimalLimit = useSelector((state) => state?.users?.coinDecimals);
  const isKycApproved = userData?.kyc_status === "APPROVED";
  const equityPrice = useSelector((state) => state?.users?.equityPrice);
 

  const spot = useSelector((state) => state?.users?.spotPrice);

  const getSpotPrice = async (data) => {
    try {
      const assets = [
        { symbol: "XAU/USD", asset: "Gold STBL" },
        { symbol: "XAG/USD", asset: "Silver STBL" },
      ];
      let spotObj = {};
      assets.map(async (token, index) => {
        const params = {
          symbol: token.symbol,
        };

        const response = await dispatch(getSpotPriceAction(params));
        if (response.status === 200) {
          spotObj[token.asset] = response?.data?.data?.Ask;
        }
      });
    } catch (error) {
      console.log("error", error);
    }
  };
  const getUserInfo = async (data) => {
    try {
      const response = await dispatch(getUserInfoAction());
      if (response?.status === 200) {
        setProfitSharing(response.data.data.equity_percentage);
      }
    } catch (error) {
      console.log("Something went wrong:", error);
    }
  };

  const equityProfit = (profitSharig * profitPrices?.getTotalEquityValue) / 100;

  const getUsersInvestment = async (data) => {
    try {
      let params = {};
      if (data === "Qty") {
        params.sortByQuantity = quantityOrder == true ? "ASC" : "DESC";
      }
      if (data === "Average") {
        params.sortByAverage = averageOrder == true ? "ASC" : "DESC";
      }
      if (data === "Price") {
        params.sortByPrice = priceOrder == true ? "ASC" : "DESC";
      }

      const response = await dispatch(getUsersInvestmentAction(params));
      if (response?.status === 200) {
        const userData = response.data.data?.getUserInvestments?.tokenSales;
        const imageUrlResponse = response?.data?.data?.imageUrl;
        setImageUrl(imageUrlResponse);
        setInvestmentList(userData);
      }
    } catch (error) {
      console.log("Something went wrong:", error);
    }
  };

  const callBackOnClick = (data) => {
    setCallbackData(data);
    if (data === "Qty") {
      setQuantityOrder((prevIsTrue) => !prevIsTrue);
      getUsersInvestment(data);
    }
    if (data === "Price") {
      setPriceOrder((prevIsTrue) => !prevIsTrue);
      getUsersInvestment(data);
    }
    if (data === "Average") {
      setAverageOrder((prevIsTrue) => !prevIsTrue);
      getUsersInvestment(data);
    }
  };

  const getTokenPrice = (item) => {
    let price = 0;
    if (item?.id == 1) {
      price = formatPrice(Number(spot?.goldPrice || 0, 2, 2));
    } else if (item?.id == 2) {
      price = formatPrice(Number(spot?.silverPrice || 0, 2, 2));
    } else if (item?.name == "Profit Sharing Token") {
      price = formatPrice(
        Number(profitPrices?.getProfitSharingPerUser || 0, 2, 2)
      );
    } else if (item?.name == "Equity") {
      price = (equityPrice?.price);
    }
    return price;
  };

  //

  // const calculatePercentageChange = (oldValue, newValue) => {
  //   let percentageChange;
  //   if (oldValue?.id == 1 && newValue?.id == 1) {
  //     percentageChange =
  //       ((newValue?.goldPrice - oldValue?.averagePrice) /
  //         Math.abs(oldValue?.averagePrice)) *
  //       100;

  //     return formatPrice(Number(percentageChange));
  //   } else if (oldValue?.id == 2 && newValue?.id == 2) {
  //     percentageChange =
  //       ((newValue?.silverPrice - oldValue?.averagePrice) /
  //         Math.abs(oldValue?.averagePrice)) *
  //       100;
  //     return formatPrice(Number(percentageChange));
  //   } else return formatPrice(Number(oldValue?.changePerc));
  // };

  useEffect(() => {
    getSpotPrice();
    getUsersInvestment();
    getUserInfo();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <Card
      title="My Investments"
      className={`${styles.investments} ${className || ""}`}
      headerClassName={`${styles.header} ${headerClassName || ""}`}
      headerContent={
        isKycApproved &&
        viewButton && (
          <>
            <Button
              onClick={() => navigate(ROUTES.INVESTMENTS)}
              variant="small_size text_blue"
            >
              View All
            </Button>
          </>
        )
      }
    >
      <Table
        noRecordContent={
          noRecordContent ||
          "It looks like you're just getting started on your investment journey."
        }
        loading={loading}
        noRecordClassName={`${styles.no_content} ${noRecordClassName || ""}`}
        noRecordVariant={noContentVariant}
        fields={fields}
        onClick={callBackOnClick}
        loadingClassName={"loading_table"}
        className={styles.table}
      >
        {isKycApproved &&
          investmentList &&
          investmentList.length > 0 &&
          investmentList.map((item, index) => (
            <tr key={index}>
              <td>
                <div className={styles.asset_detail}>
                  <img src={imageUrl + item.image} alt="" />
                  <div className={styles.asset_inner}>
                    <h6>{item.name}</h6>
                    <div className={styles.asset_invested}>
                      <p>{item.perc?.toFixed(2)}%</p>
                      <div className={styles.progress}>
                        <span style={{ width: `${item.perc}%` }} />
                      </div>
                    </div>
                  </div>
                </div>
              </td>

              <td>{toFix(Number(item?.quantity), 3)}</td>
              {/* <td>{formatPrice(Number(item?.locked_quantity))}</td>
              <td>
                {formatPrice(
                  Number(item?.quantity || 0) +
                    Number(item?.locked_quantity || 0)
                )}
              </td> */}
              <td>${getTokenPrice(item)}</td>
              <td>
                <h6
                  className={`${styles.change_text} ${
                    item?.name !== "Equity" && item?.changePerc < 0
                      ? styles.negative
                      : item?.name !== "Equity"
                      ? styles.positive
                      : ""
                  }`}
                >
                  {item?.name !== "Equity" && (
                    <span>
                      <RightUpIcon />
                    </span>
                  )}
                  {item.name === "Equity" ? "N/A" : formatPrice(item?.changePerc)}
                </h6>
              </td>
              <td>
                <Button
                  onClick={() => navigate(ROUTES.BUY)}
                  className={styles.trade_btn}
                >
                  Trade
                </Button>
              </td>
            </tr>
          ))}
      </Table>
    </Card>
  );
};


export default InvestmentsCard;
